<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <Festival />
  </v-container>
</template>

<script>
	import Festival from '../../components/Festival/Festival'
	export default {
		components:{
			Festival,
		},
    data:()=>({
      //BOC:[breadcrumbs]
      breadcrumbs: [],
      //EOC
    }),
    created() {
      //BOC:[breadcrumbs]
      this.breadcrumbs.push({
        text:this.$t("route.PageMainHome"),
        to:{name:'PageMainHome'},
        exact:true,
      })
      this.breadcrumbs.push({
        text:this.$t("route.PageMainFestival"),
        to:{name:'PageMainFestival'},
        exact:true,
      })
      //EOC
    },
	};
</script>